












import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import _ from "lodash";

@Component({
    components: {

    }
})
export default class SystemBarSearch extends BaseComponent {

    // Bindings to parent

    // Bindings to view
    public isReady = false;
    public value = '';
    private debouncedSearch = _.debounce(this.doSearch, 300);

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.isReady = true;
    }

    public onSearchChange() {
        this.debouncedSearch();
    }

    private doSearch() {
        if (this.value.length) {
            this.$router.push({
                name: 'ClientSearch',
                params: {
                    search: this.value,
                }
            }).catch(_ => {});
            this.value = '';
        }
    }

}
